/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AlertCircle,
  CheckCircle,
  Clock,
  ClipboardList,
  UserCheck,
  List,
  Grid3X3,
  Award,
} from "lucide-react";
import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useSnackbar } from "../../../../_theme/context/SnackbarContext";
import { encodeBase64 } from "../../../../utils/config";
import { IDashboardFilterData } from "../../core/_models";
import { Link } from "react-router-dom";
import ProgressBar from "../../apps/components/ProgressBar";
import { getEvaluationProjectCounts } from "../../project/core/_project_evaluation";
import ProjectList from "./Evaluation/projectList";
import EvaluatorList from "./Evaluation/evaluatorList";
import { useDebounce } from "../../../../_theme/helpers/crud-helper/helpers";
import { EvaluationStatusFilter } from "../../project/core/_models";
import EvaluatorGridView from "./Evaluation/EvaluatorGridView";
import { useAuth } from "../../auth";
import { LogError } from "../../../../utils/GlobalLogging";
import SkeletonCard from "../../apps/components/skeleton/SkeletonCard";
import { getApiErrorMessage } from "../../../../utils/utils";
import { isAbortedError } from "../../../../utils/global";
import SectionHeader from "./SectionHeader";
const tabList = [
  {
    tabKey: EvaluationStatusFilter.all,
    tabTitle: "All",
  },
  {
    tabKey: EvaluationStatusFilter.pending,
    tabTitle: "Pending",
  },
  {
    tabKey: EvaluationStatusFilter.overdue,
    tabTitle: "Overdue",
  },
  {
    tabKey: EvaluationStatusFilter.completed,
    tabTitle: "Completed",
  }
];
const MyProjectCard: FC<{ filters: IDashboardFilterData }> = ({ filters }) => {
  const { showSnackbar } = useSnackbar();
  const { auth } = useAuth();
  const [loading, setLoading] = useState<boolean>(true);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 500);
  const [viewMode, setViewMode] = useState<"grid" | "list">("grid");
  const [activeTab, setActiveTab] = useState<EvaluationStatusFilter>(EvaluationStatusFilter.all);
  const [evaluatorModeOn, setEvaluatorModeOn] = useState<boolean>(false);

  // New: dynamic counts from API
  const [evaluationProjectCounts, setEvaluationProjectCounts] = useState({
    total_evaluation_projects: 0,
    total_pending: 0,
    total_completed: 0,
    total_overdue: 0,
    total_await_sign_off: 0,
    can_manage_evaluation_reminders: false,
  });
  const abortControllerRef = useRef<AbortController | null>(null);

  // Fetch evaluation project counts
  const fetchtEvaluationCounts = useCallback(async () => {
    abortControllerRef.current?.abort();
    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      setLoading(true);
      const countsResponse = await getEvaluationProjectCounts(controller.signal);

      if (controller.signal.aborted) return;

        if (countsResponse.status === "ok") {
        setEvaluationProjectCounts(prev => ({
          ...prev,
          ...countsResponse.data,
          can_manage_evaluation_reminders: countsResponse.data.can_manage_evaluation_reminders === true,
        }));
      }else{
        showSnackbar(countsResponse.message, "danger");
      }
    } catch (error) {
      if (isAbortedError(error)) return;
      showSnackbar(getApiErrorMessage(error, "Failed to fetch evaluation counts"), "danger");
      LogError("Failed to fetch evaluation counts:", error,"MyProjectCard");
    } finally {
      if (!controller.signal.aborted) {
        setLoading(false);
      }
    }
  }, [showSnackbar]);

  const handleEvaluatorMode = useCallback((mode: boolean) => {
    setEvaluatorModeOn(mode);
    setSearch('');
  }, [activeTab]);

  const canUseEvaluationList = auth?.isAdmin == 1 || evaluationProjectCounts.can_manage_evaluation_reminders === true;

  useEffect(() => {
    fetchtEvaluationCounts();
    return () => {
      abortControllerRef.current?.abort();
    };
  }, [fetchtEvaluationCounts]);

  useEffect(() => {
    if (canUseEvaluationList) {
      setViewMode("list");
    } else {
      setViewMode("grid");
    }
  }, [canUseEvaluationList]);

  //if (loading) return <Loader loadingText="Loading project evaluation..." />;

  // Define quick stats dynamically
  const quickStats = useMemo(() => [
    {
      label: "Total Evaluations",
      value: evaluationProjectCounts.total_evaluation_projects,
      icon: ClipboardList,
      iconColor: "primary"
    },
    {
      label: "Completed",
      value: evaluationProjectCounts.total_completed,
      icon: CheckCircle,
      iconColor: "success"
    },
    {
      label: "Pending",
      value: evaluationProjectCounts.total_pending,
      icon: Clock,
      iconColor: "dark-orange"
    },
    {
      label: "Overdue",
      value: evaluationProjectCounts.total_overdue,
      icon: AlertCircle,
      iconColor: "danger"
    },
    // {
    //   label: "Await Sign-Off",
    //   value: evaluationProjectCounts.total_await_sign_off,
    //   icon: UserCheck,
    //   iconColor: "info"
    // },
  ], [evaluationProjectCounts]);

  const completionRate = useMemo(() => {
    return Number(((evaluationProjectCounts.total_completed / evaluationProjectCounts.total_evaluation_projects) * 100).toFixed(2)) || 0;
  }, [evaluationProjectCounts.total_completed, evaluationProjectCounts.total_evaluation_projects]);


  const handleActiveTab = useCallback((tab: EvaluationStatusFilter) => {
    setActiveTab(tab);
    setEvaluatorModeOn(false);
    setSearch('');
  }, []);


  return (
    <div className="position-relative w-100">
      <SectionHeader
        title="Project Evaluation"
        description="Comprehensive Scoring Of Assessment Of Legislative Compliance For All Projects"
        icon={Award}
        action={auth?.isAdmin == 1 ? (
          <div className="d-flex align-items-center flex-column flex-sm-row justify-content-between gap-4 w-100 w-lg-auto">
            <div className="rounded-2xl p-1 text-center w-100px">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{"Grid View"} </Tooltip>}
              >
                <button
                  onClick={() => setViewMode("grid")}
                  className={`p-3 border border-0 rounded-circle ${viewMode === "grid"
                    ? "bg-primary text-white shadow-apple-sm"
                    : "text-muted bg-white"
                    }`}
                  disabled={loading}
                >
                  <Grid3X3 className="h-4 w-4" />
                </button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{"List View"} </Tooltip>}
              >
                <button
                  onClick={() => setViewMode("list")}
                  className={`p-3 border border-0 rounded-circle ${viewMode === "list"
                    ? "bg-primary text-white shadow-apple-sm"
                    : "text-muted bg-white"
                    }`}
                  disabled={loading}
                >
                  <List className="h-4 w-4" />
                </button>
              </OverlayTrigger>
            </div>
          </div>
        ) : undefined}
      />

      {/* Quick Stats Section */}
      <Row className="gap-0 mb-3 mb-lg-5 row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-4">
        {
          loading ? (
            Array.from({ length: 4 }).map((_, index) => (
              <div key={index} className="col-12 col-sm-6 col-lg-3">
                <SkeletonCard
                  wrapperClassName=""
                  className="mb-4"
                  titleWidth="100%"
                  valueWidth="100%"
                  showIcon={true}
                  iconSide="left"
                  lines={0}
                />
              </div>
            ))
          ) : (
            quickStats.map((stat, index) => (
              <div key={index} className="col">
                <Link to={`/projects/?label=${encodeBase64(stat.label === "Completed" ? 'Projects Evaluations Completed' : stat.label)}&dashboard=${encodeBase64("Project Evaluation")}&url=${encodeBase64('dashboard/evaluation')}&filter=${encodeBase64(JSON.stringify(filters))}`} className="text-decoration-none d-flex h-100 w-100">
                  <div className="apple-card gestalt-group group border-0 shadow-sm rounded-5 p-5 w-100 mb-4 mb-lg-0">
                    <div className="d-flex align-items-center">
                      <div className="d-flex align-items-start justify-content-center rounded me-3">
                        <div
                          className={`p-3 rounded-circle shadow-apple-sm bg-${stat.iconColor}`}>
                          {stat.icon && <stat.icon className="h-6 w-6 text-white" />}
                        </div>
                      </div>
                      <div>
                        <p className={`apple-title fw-bold mb-0 text-${stat.iconColor}`}>{stat.value}</p>
                        <p className="apple-caption text-muted fw-light mb-0">{stat.label}</p>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            )))
        }
      </Row>
      {auth?.isAdmin == 0 && !canUseEvaluationList &&
        <Row className="mb-5">
          <Col>
            <div className="apple-card gestalt-group group border-0 shadow-sm rounded-5 p-5 w-100 mb-4 mb-lg-0">
              <div>
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <p className={`apple-title fw-bold mb-0 fs-4`}>Overall Completion Rate</p>
                    <p className="apple-caption text-muted fw-light mb-0">{evaluationProjectCounts.total_completed} of {evaluationProjectCounts.total_evaluation_projects} evaluations completed</p>
                  </div>
                  <div>
                    <p className={`apple-title fs-1x fw-bold mb-0 text-info`}>{completionRate}%</p>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <ProgressBar onlyProgressBar={true} size="md" percentage={completionRate} bgColor="primary-light" />
              </div>
            </div>
          </Col>
        </Row>}
      <Row className="mb-5 align-items-center">
        <Col>
          <div className="gestalt-group group border-0 shadow-sm rounded-4 p-2 w-100 mb-4 mb-lg-0">
            <input
              type="text"
              className="form-control form-control-md border-0 shadow-none bg-transparent"
              placeholder={`Search ${evaluatorModeOn?'evaluators':'projects'}`}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              disabled={loading}
            />
          </div>
        </Col>
        {(canUseEvaluationList && viewMode === "list") &&
          <Col className="col-auto">
            <ul className="nav rounded-4 nav-pills-custom flex-nowrap overflow-auto gap-3 bg-light p-2">
              {tabList.map((tab) => (
                <li key={tab.tabKey} className="nav-item me-0">
                  <button
                    type="button"
                    onClick={() => handleActiveTab(tab.tabKey)}
                    disabled={loading}
                    className={`nav-link fs-7 px-4 py-2 rounded-4 border-0 
                    ${activeTab === tab.tabKey
                        ? "active text-white bg-primary shadow-sm"
                        : "bg-gray-200 text-gray-700"
                      }`}
                  >
                    {tab.tabTitle}
                  </button>
                </li>
              ))}
            </ul>
          </Col>}
      </Row>
      {viewMode === "grid" ? <EvaluatorGridView search={debouncedSearch?.toString() || ''} filters={filters} /> : <>
        {evaluatorModeOn ? <EvaluatorList evaluatorModeOn={evaluatorModeOn} handleEvaluatorMode={handleEvaluatorMode} search={debouncedSearch?.toString() || ''} activeTab={activeTab} setActiveTab={setActiveTab} /> : <ProjectList search={debouncedSearch?.toString() || ''} activeTab={activeTab} evaluatorModeOn={evaluatorModeOn} handleEvaluatorMode={handleEvaluatorMode} filters={filters} />}
      </>}

    </div>
  );
};

export { MyProjectCard };